import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Box, Button, Divider, TextField, Typography } from '@mui/material'
import { ColorBoxContent } from 'common/ui/colorBox'
import { CheckIcon } from 'common/ui/icons'
import numeral from 'numeral'
import PropTypes from 'prop-types'

import QuotationAPI from '../../../../../api/orbitV1/QuotationAPI'
import JoyrideContext from '../../../../../context/joyride/joyrideContext'
import OrbitSession from '../../../../../hooks/useCookies'

function OrderReview(props) {
  const {
    children,
    planId,
    plans,
    numberOfSims,
    totalPrice,
    addOnPrice,
    handleCreate,
    unexpectedError,
    goPreviousPage,
    setDialogOpen
  } = props

  // TODO: [EK] after migration this will break
  const orgId = OrbitSession.get('orgId')
  const userId = OrbitSession.get('_id')
  const userEmail = OrbitSession.get('email')
  const [email, setEmail] = useState(userEmail)
  const joyrideContext = useContext(JoyrideContext)
  const { tourActive, setRun } = joyrideContext

  useEffect(() => {
    if (tourActive) {
      setTimeout(() => {
        setRun(true)
      }, 500)
    }
  }, [])

  const handleGenerateQuotation = async () => {
    try {
      const quotationCreated = await QuotationAPI.createNewQuotation({
        items: plans,
        price: totalPrice,
        orgId,
        userId,
        numberOfSims,
        email
      })

      if (quotationCreated) {
        toast.success(`Quotation has been generated and sent to ${email}!`)
      }
    } catch (err) {
      toast.error('Unexpected error accepting quotation!')
    }
  }

  return (
    <>
      <Box sx={{ padding: '0px 24px', width: '100%' }}>
        <Typography variant='h4'>Please Choose Your Payment Method</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            padding: `0px 40px`,
            justifyContent: 'space-between'
          }}
        >
          <Button
            variant='secondary'
            sx={{ height: '50px' }}
            onClick={goPreviousPage}
            id='editDetailsButton'
          >
            Edit Details
          </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            width: '100%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '50%',
              margin: `24px 0`
            }}
          >
            <ColorBoxContent
              variant='secondary'
              style={{ padding: 0, width: '100%', minHeight: '512px' }}
            >
              <Box
                sx={{
                  padding: `24px 0 16px 24px`
                }}
              >
                <Typography variant='h4' sx={{ margin: 0 }}>
                  Plan Selected
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  backgroundColor: 'primary.main',
                  padding: `4px 24px`
                }}
              >
                <Typography variant='h4' sx={{ color: 'white' }}>
                  {plans[planId].productName}
                </Typography>
                <Typography variant='h4' sx={{ color: 'white' }}>
                  SGD${totalPrice.toFixed(2)}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '24px'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <Typography>
                    <b>Breakdown</b>
                  </Typography>
                  <Typography>
                    <b>
                      {numberOfSims} x SGD$
                      {plans[planId].baseplan.price.value.toFixed(2)}
                    </b>
                  </Typography>
                </Box>
                {[
                  {
                    key: 'plan-data',
                    field: numeral(plans[planId].baseplan.data * 1000).format(
                      '0b'
                    )
                  },
                  {
                    key: 'plan-voice',
                    field: `${plans[planId].baseplan.voice} min`
                  },
                  {
                    key: 'plan-sms',
                    field: `${plans[planId].baseplan.sms} SMS`
                  },
                  { key: 'plan-customizable', field: '100% Customizable' }
                ].map(({ key, field }) => {
                  return (
                    <Box
                      key={key}
                      sx={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <CheckIcon />
                      <Typography sx={{ margin: '8px' }}>{field}</Typography>
                    </Box>
                  )
                })}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '40px'
                  }}
                >
                  <Typography>
                    <b>Add-Ons</b>
                  </Typography>
                  <Typography>
                    <b>SGD${addOnPrice.toFixed(2)}</b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <CheckIcon />
                  <Typography sx={{ margin: '8px' }}>None</Typography>
                </Box>
              </Box>
            </ColorBoxContent>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '50%',
              margin: `24px 36px`
            }}
          >
            <div id='buyNewSim__paymentOptions'>
              <ColorBoxContent
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '200px',
                  margin: '6px 0px'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    justifyContent: 'space-between'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography variant='h4' sx={{ margin: 0 }}>
                      Generate Quotation
                    </Typography>

                    <Typography sx={{ fontSize: '14px' }}>
                      A PDF version of the quotation will be emailed to the
                      email address provided.
                    </Typography>
                    <TextField
                      label='email'
                      value={email}
                      sx={{ width: '100%' }}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      width: '100%'
                    }}
                  >
                    <Button
                      variant='filled'
                      sx={{
                        height: '60px',
                        width: '70%',
                        textAlign: 'center',
                        margin: '2px'
                      }}
                      onClick={handleGenerateQuotation}
                      // temporarily disable this for now as it is not a supported function
                      disabled={!email || 'true'}
                      id='generateQuotation'
                    >
                      Generate Quotation
                    </Button>
                  </Box>
                </Box>
              </ColorBoxContent>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Divider sx={{ width: '50%' }} />
                <Typography
                  variant='h4'
                  display='inline-block'
                  sx={{ fontSize: '14px' }}
                >
                  OR
                </Typography>
                <Divider sx={{ width: '50%' }} />
              </Box>

              <ColorBoxContent
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '160px'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'center',
                      marginBottom: '20px'
                    }}
                  >
                    <Typography variant='h4' sx={{ margin: 0 }}>
                      Proceed to Payment Method Selection
                    </Typography>
                    <Typography>
                      {children}
                      <Typography sx={{ color: 'error' }}>
                        {unexpectedError}
                      </Typography>
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      id='confirmOrderButton'
                      aria-label='confirm order'
                      display='flex'
                      variant='filled'
                      sx={{ height: '50px' }}
                      onClick={() => {
                        handleCreate()
                        setDialogOpen(true)
                      }}
                      data-cy='confirmOrderButton'
                    >
                      Confirm Order
                    </Button>
                  </Box>
                </Box>
              </ColorBoxContent>
            </div>
          </Box>
        </Box>
      </Box>
    </>
  )
}

OrderReview.propTypes = {
  children: PropTypes.node,
  planId: PropTypes.number.isRequired,
  plans: PropTypes.array.isRequired,
  numberOfSims: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  addOnPrice: PropTypes.number.isRequired,
  handleCreate: PropTypes.func,
  unexpectedError: PropTypes.string.isRequired,
  goPreviousPage: PropTypes.func.isRequired,
  setDialogOpen: PropTypes.func.isRequired
}

export default OrderReview
